<template>
    <div class="foundation-entry foundation-entry-foundation page-layout-default static-foundation-page-content">
        <div class="foundation entry-content">
            <div class="content-blocks">
                <div class="block block-text-standard container-fluid">
                    <div class="row content-block-row">
                        <div class="col-12 col-lg-3"></div>
                        <div class="col-12 col-md-9 mx-md-auto mx-lg-0 col-lg-6">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import SiteFooter from '@/components/SiteFooter';
export default {
  name: 'StaticFoundationPageContent',
  components: {
      //SiteFooter
  }
}
</script>
